module.exports = __webpack_public_path__ + "static/img/company-logo1.c932f74e.jpg";